/** @jsxImportSource @emotion/react */
import { useSearchParams } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import React, { useState } from 'react'
import { usePlatformsAndSubjects } from 'hooks/usePlatformsAndSubjects'
import { PageLoader } from 'components/PageLoader'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import { QUERY_PARAM } from 'pagesNew/Users'
import { AITestResponseTypeEnum, AITestTypeEnum } from '__generatedTypes__/globalTypes'
import * as classes from './styles'
import { DataList } from './DataList'

export const AI_TESTS_KEY = 'AITests'
export const SECTION_QUERY_PARAM = 'sectionTab'

const SECTION_TABS: Array<{ id: AITestResponseTypeEnum | typeof AI_TESTS_KEY; title: string }> = [
  {
    id: AI_TESTS_KEY,
    title: 'Video/Text Response Tests',
  },
  {
    id: AITestResponseTypeEnum.VideoResponse,
    title: 'FLT Video-Response',
  },
  {
    id: AITestResponseTypeEnum.TextResponse,
    title: 'FLT Typed-Response',
  },
]

const TABS: Array<{ id: AITestTypeEnum; title: string }> = [
  {
    id: AITestTypeEnum.VideoTest,
    title: 'Video-Prompt',
  },
  {
    id: AITestTypeEnum.TextTest,
    title: 'Text-Prompt',
  },
]

export const TrainingData = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { selectedPlatform } = usePlatformsAndSubjects({})
  const [activeSectionTab, setActiveSectionTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(SECTION_QUERY_PARAM)
    return SECTION_TABS.find(({ id }) => id === tabId) || SECTION_TABS[0]
  })
  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(QUERY_PARAM)
    return TABS.find(({ id }) => id === tabId) || TABS[0]
  })

  const handleChangeSectionTab = (activeSectionTab: TabsItem) => {
    setSearchParams((prev) => ({
      ...Object.fromEntries(prev.entries()),
      [SECTION_QUERY_PARAM]: activeSectionTab.id,
    }))
    setActiveSectionTab(activeSectionTab)
  }

  const handleChangeTab = (activeTab: TabsItem) => {
    setSearchParams((prev) => ({
      ...Object.fromEntries(prev.entries()),
      [QUERY_PARAM]: activeTab.id,
    }))
    setActiveTab(activeTab)
  }

  if (!selectedPlatform) {
    return <PageLoader />
  }

  return (
    <section css={classes.container}>
      <Typography css={classes.header} variant="title3">
        CasperBooster Grade Editor
      </Typography>

      <TabsNavigation
        css={classes.sectionTabs}
        tabs={SECTION_TABS}
        value={activeSectionTab}
        onChange={handleChangeSectionTab}
      />
      <TabsNavigation css={classes.tabs} tabs={TABS} value={activeTab} onChange={handleChangeTab} />

      <DataList
        responseType={activeSectionTab.id === AI_TESTS_KEY ? null : (activeSectionTab.id as AITestResponseTypeEnum)}
        type={activeTab.id as AITestTypeEnum}
      />
    </section>
  )
}
